/**
 * O card do Resumo do dia: só fatos, sem texto gerado. Antes da hora do
 * resumo, mostra o parcial e diz quando fica pronto.
 */
import { formatMoney } from '@nv/core';
import { Link } from 'react-router-dom';

import { Icon } from '../../ui/icons';
import { Card } from '../../ui/primitives';
import type { ResumoDoDia } from './api';

const ddmm = (iso: string) => `${iso.slice(8, 10)}/${iso.slice(5, 7)}`;

export function ResumoDoDiaCard({ resumo, compacto = false }: { resumo: ResumoDoDia; compacto?: boolean }) {
  const vazio = resumo.activities.done === 0 && resumo.photos.count === 0 && resumo.groupSpentMinor === 0 && !resumo.meeting && resumo.polls.length === 0;
  return (
    <Card className="resumo" data-testid="resumo-do-dia">
      <div className="resumo__cab">
        <span className="rk__cat-icone"><Icon name="destaque" size={18} /></span>
        <span className="rk__linha-texto">
          <span className="rk__linha-nome">Resumo de {ddmm(resumo.date)}{resumo.title ? ` · ${resumo.title}` : ''}</span>
          <span className="rk__linha-familia">{resumo.ready ? 'O dia está pronto' : `Parcial — fica pronto às ${resumo.summaryTime}`}</span>
        </span>
        {compacto && <Link to={`/memorias/${resumo.date}`} className="rk__home-link">Ver <Icon name="avancar" size={14} /></Link>}
      </div>

      {vazio && <p className="enq__vazio">Nada registrado neste dia ainda.</p>}

      {!vazio && (
        <ul className="resumo__lista">
          <li className="resumo__item">
            <Icon name="concluir" size={16} />
            <span>
              <b>{resumo.activities.done} de {resumo.activities.total}</b> {resumo.activities.total === 1 ? 'atividade concluída' : 'atividades concluídas'}
              {!compacto && resumo.activities.items.length > 0 && <span className="resumo__detalhe"> · {resumo.activities.items.slice(0, 4).map((a) => a.title).join(' · ')}{resumo.activities.items.length > 4 ? ' · …' : ''}</span>}
            </span>
          </li>
          {resumo.photos.count > 0 && (
            <li className="resumo__item">
              <Icon name="memorias" size={16} />
              <span><b>{resumo.photos.count}</b> {resumo.photos.count === 1 ? 'foto' : 'fotos'}</span>
              {resumo.photos.thumbUrls.length > 0 && (
                <span className="resumo__fotos" aria-hidden="true">
                  {resumo.photos.thumbUrls.map((u, i) => <img key={i} src={u} alt="" loading="lazy" />)}
                </span>
              )}
            </li>
          )}
          {resumo.groupSpentMinor > 0 && (
            <li className="resumo__item">
              <Icon name="dinheiro" size={16} />
              <span>Gasto do grupo: <b className="mono">{formatMoney(resumo.groupSpentMinor, resumo.currency)}</b> <span className="resumo__detalhe">(só o compartilhado)</span></span>
            </li>
          )}
          {resumo.stamps.length > 0 && (
            <li className="resumo__item">
              <Icon name="carimbo" size={16} />
              <span>{resumo.stamps.length === 1 ? 'Carimbo novo' : 'Carimbos novos'}: <b>{resumo.stamps.join(', ')}</b></span>
            </li>
          )}
          {resumo.meeting && (
            <li className="resumo__item">
              <Icon name="ponto" size={16} />
              <span>Ponto de encontro <b>{resumo.meeting.title}</b>{resumo.meeting.firstArrival ? ` · ${resumo.meeting.firstArrival} chegou primeiro` : ''} · {resumo.meeting.arrivals} {resumo.meeting.arrivals === 1 ? 'chegou' : 'chegaram'}</span>
            </li>
          )}
          {resumo.polls.map((p) => (
            <li className="resumo__item" key={p.question}>
              <Icon name="enquete" size={16} />
              <span>{p.question} <b>{p.winner ?? 'sem votos'}</b></span>
            </li>
          ))}
        </ul>
      )}
    </Card>
  );
}
